import { render } from "./VerifyEmail.vue?vue&type=template&id=74c85afe&scoped=true"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"

import "./VerifyEmail.vue?vue&type=style&index=0&id=74c85afe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-74c85afe"

export default script